import { useTranslation } from '@hooks';
import { useServicesStore } from '@store';
import { ChallengeTypeEnum } from '@types';

export const resources = {
	password: {
		text: 'components.footer.password.text',
		link: {
			text: 'components.footer.password.link.text',
			url: 'components.footer.password.link.url',
		},
	},
	multichannel: {
		text: 'components.footer.multichannel.text',
		link: {
			text: 'components.footer.multichannel.link.text',
			url: 'components.footer.multichannel.link.url',
		},
	},
};

export const useFooterHelper = () => {
	const { t } = useTranslation();
	const { challengeType } = useServicesStore((store) => store.accountLogin) || {};

	const isMultichannel =
		challengeType === ChallengeTypeEnum.Multichannel ||
		challengeType === ChallengeTypeEnum.MultichannelCompanyOperatorCoHolder;

	const translationKey: 'password' | 'multichannel' = isMultichannel ? 'multichannel' : 'password';

	const showText = t(resources[translationKey].text) !== resources[translationKey].text;

	const showLink =
		t(resources[translationKey].link.text) !== resources[translationKey].link.text &&
		t(resources[translationKey].link.url) !== resources[translationKey].link.url;

	return { t, translationKey, showText, showLink };
};
